/**
 * View and ViewSwitcher components, are not production ready as they still require context to work
 * Each view is located in a separate subfolder, to create a new view - use tabViewFactory
 * (to keep the code clean by generating same layout and applying different styles)
 * Or create a new component, if something more complicated is required
 *
 * All the view components must be enhanced by withContext to work as is,
 * or can be combined into SimpleTabsListView Switch and become a part of Flexible TabsList/Item group
 */

import React from 'react';
import PropTypes from 'prop-types';

import {
  TAB_TYPE_UNDERLINED,
  TAB_TYPE_MENU,
  TAB_TYPE_MENU_FILLED,
  TabViewTypes,
  TAB_TYPE_FILTER,
  TAB_TYPE_CALENDAR,
  TAB_TYPE_RADIO,
  TAB_TYPE_SEGMENTED,
} from '../constants';
import { UnderlinedTabsList, UnderlinedTabsItem } from './UnderlinedTabs';
import { MenuFilledTabsList, MenuFilledTabsItem } from './MenuFilledTabs';
import { CalendarTabsList, CalendarTabsItem } from './CalendarTabs';
import { RadioTabsList, RadioTabsItem } from './RadioTabs';
import { SegmentedTabsList, SegmentedTabsItem } from './SegmentedTabs';
import { FilterTabsList, FilterTabsItem } from './FilterTabs';
import { MenuTabsList, MenuTabsItem } from './MenuTabs';

export function SimpleTabsListView(props) {
  switch (props.type) {
    case TAB_TYPE_UNDERLINED:
      return <UnderlinedTabsList {...props} />;
    case TAB_TYPE_MENU_FILLED:
      return <MenuFilledTabsList {...props} />;
    case TAB_TYPE_MENU:
      return <MenuTabsList {...props} />;
    case TAB_TYPE_FILTER:
      return <FilterTabsList {...props} />;
    case TAB_TYPE_CALENDAR:
      return <CalendarTabsList {...props} />;
    case TAB_TYPE_RADIO:
      return <RadioTabsList {...props} />;
    case TAB_TYPE_SEGMENTED:
      return <SegmentedTabsList {...props} />;
    default:
      return null;
  }
}

SimpleTabsListView.propTypes = {
  /** universal tab type */
  type: PropTypes.oneOf(TabViewTypes).isRequired, // represents type of the tab

  /** unified tabList interface */
  children: PropTypes.node,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export function SimpleTabsItemView({ type, ...props }) {
  switch (type) {
    case TAB_TYPE_UNDERLINED:
      return <UnderlinedTabsItem {...props} />;
    case TAB_TYPE_MENU_FILLED:
      return <MenuFilledTabsItem {...props} />;
    case TAB_TYPE_MENU:
      return <MenuTabsItem {...props} />;
    case TAB_TYPE_FILTER:
      return <FilterTabsItem {...props} />;
    case TAB_TYPE_CALENDAR:
      return <CalendarTabsItem {...props} />;
    case TAB_TYPE_RADIO:
      return <RadioTabsItem {...props} />;
    case TAB_TYPE_SEGMENTED:
      return <SegmentedTabsItem {...props} />;
    default:
      return null;
  }
}

SimpleTabsItemView.propTypes = {
  /** universal tab type */
  type: PropTypes.oneOf(TabViewTypes), // represents type of the tab

  /** unified tab interface */
  children: PropTypes.node,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  prefix: PropTypes.node, // extra children before tab
  postfix: PropTypes.node, // extra children after tab
  count: PropTypes.number, // digit displayed within postfix area next to the tab
  className: PropTypes.string,
};
